import api from './api';

// 📌 Récupérer les réservations d’un jour spécifique (Admin)
export const getReservationsParJour = async (date) => {
  try {
    const response = await api.get('/admin/reservations', {
      params: { jour: date }
    });
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des réservations du jour (Admin)', error);
    return [];
  }
};

// 📌 Réservations d'une période, 31 jours au plus (Admin), en une seule requête.
// Renvoie [{ id, jour: 'YYYY-MM-DD', heure_debut: 'HH:MM', duree_totale_minutes, mode, departement, ville, nom, prenom }]
// triées par jour puis heure. Contrairement à getReservationsParJour, une erreur est
// remontée : l'écran « Semaine exceptionnelle » ne doit pas afficher « 0 réservation »
// (et donc aucun conflit) simplement parce que l'appel a échoué.
export const getReservationsPeriode = async (debut, fin) => {
  const response = await api.get('/admin/reservations', {
    params: { debut, fin }
  });
  return response.data;
};

// 📌 Récupérer les détails complets d'une réservation (Admin)
export const getDetailsReservationAdmin = async (reservationId) => {
  try {
    const response = await api.get(`/admin/reservations/${reservationId}`);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la récupération des détails (Admin)', error);
    return null;
  }
};

// 📌 Annuler plusieurs rendez-vous en une seule requête (Admin), en prévenant les clients.
// annulations : [{ id, jour: 'YYYY-MM-DD', heure_debut: 'HH:MM', raison?, motif? }] (1 à 100,
// sans id en double). Le backend n'annule un rendez-vous que s'il est toujours à ce jour et à
// cette heure, et pas encore commencé ; chacun est traité séparément.
// Renvoie { resultats: [{ id, statut: 'annulee' | 'introuvable' | 'deplacee' | 'passee' | 'erreur',
// reservation?, emailClient?, telephone?, actuel?: { jour, heure_debut }, message? }] }, dans
// l'ordre envoyé. Toute erreur de la requête (réseau, 400, 429, 500…) est remontée.
export const annulerReservations = async (annulations) => {
  try {
    const response = await api.post('/admin/reservations/annulations', { annulations });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'annulation des réservations (Admin)", error);
    throw error;
  }
};

// 📌 Supprimer une réservation en tant qu'Admin
// options (facultatif) : { motif, raison } envoyés dans le corps du DELETE. La cliente reçoit
// alors un e-mail d'annulation qui reprend le motif, et la réponse indique si elle a pu être
// prévenue par e-mail ({ emailClient, telephone }). raison : 'FERME' | 'SALON_UNIQUEMENT' |
// 'DOMICILE_UNIQUEMENT' | 'HORAIRES' | 'VILLE'. Un motif vide est omis.
// Sans options, l'appel est exactement celui d'avant (aucun corps).
export const supprimerReservationAdmin = async (reservationId, options) => {
  try {
    const url = `/admin/reservations/${reservationId}`;
    const corps = {};
    const motif = typeof options?.motif === 'string' ? options.motif.trim() : '';
    if (motif) corps.motif = motif;
    if (options?.raison) corps.raison = options.raison;
    const response = Object.keys(corps).length
      ? await api.delete(url, { data: corps })
      : await api.delete(url);
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la suppression de la réservation (Admin)', error);
    throw error;
  }
};